<template>
    <div>
        <div v-show="!mostrarEventos">
            <b-card no-body>
                <b-tabs>
                    <b-tab title="Plano de Trabalho">
                        <b-card-header>
                    <span class="h5">
                        
                    </span>
                </b-card-header>
                <b-card-body>
                    <div>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <app-tabela
                            idTabela="tbAcoesPlanoTrabalho"
                            :itens="acoesPlanoTrabalho"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false">
                            
                        <template slot="botoes">
                            <b-button-group class="float-right">
                                <btn-inserir-acao-plano-trabalho
                                    :convenio="convenio"
                                    class="mr-2"
                                    v-if="$temAcessoView('CONV-PLANO-01')"
                                    @atualizarLista="atualizarLista()">
                                </btn-inserir-acao-plano-trabalho>
                            </b-button-group>
                        </template>
                        <template slot="acoes" slot-scope="data">
                                <btn-atualizar-acao
                                    v-if="$temAcessoView('CONV-PLANO-01') && data.codSituacao != 1"
                                    :convenio="convenio"
                                    :acao="data"
                                    @atualizarLista="atualizarLista()">
                                </btn-atualizar-acao>
                                <btn-cancelar-acao
                                    v-if="$temAcessoView('CONV-PLANO-02') && data.codSituacao != 1"
                                    class="text-danger float-left mr-1"
                                    :convenio="convenio"
                                    :acao="data"
                                    @atualizarLista="atualizarLista()"
                                ></btn-cancelar-acao>
                                <btn-mostrar-eventos
                                    v-if="$temAcessoView('CONV-PLANO-02')"
                                    @atualizarEvento="eventos = $event"
                                    @atualizarConsultoria="consultorias = $event"
                                    @receberAcao="acao = $event"
                                    :acao="data"
                                ></btn-mostrar-eventos>
                        </template>
                            <template slot="nomeAcao" slot-scope="data">
                                <p class="text-left m-0">
                                    {{ data.nomeAcao }}
                                </p>
                            </template>
                            <template slot="situacao" slot-scope="data">
                                <p class="text-left m-0">
                                    {{ data.situacao }}
                                </p>
                            </template>
                            <template slot="valoresConvenioOriginal" slot-scope="data">
                                <b-container style="padding-left: 0px">
                                    <b-row>
                                        <b-col>Sebrae: {{ parseFloat(data.nuValorOriginalSebrae || 0).toFixed(2) }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>Parceiro: {{ parseFloat(data.nuValorOriginalParceiro || 0).toFixed(2) }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            Total: {{
                                                (parseFloat(data.nuValorOriginalParceiro || 0) + 
                                                parseFloat(data.nuValorOriginalSebrae || 0)).toFixed(2)
                                            }}
                                        </b-col>
                                    </b-row>
                                </b-container>                                
                            </template>
                            <template slot="valoresAtuais" slot-scope="data">
                                <b-container style="padding-left: 0px">
                                    <b-row>
                                        <b-col>Sebrae: {{ parseFloat(data.nuValorSebraeAtual || 0).toFixed(2) }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>Parceiro: {{ parseFloat(data.nuValorParceiroAtual || 0).toFixed(2) }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            Total: {{
                                                (parseFloat(data.nuValorSebraeAtual || 0) + 
                                                parseFloat(data.nuValorParceiroAtual || 0)).toFixed(2)
                                            }}
                                        </b-col>
                                    </b-row>
                                </b-container>                                
                            </template>
                            <template slot="variacao" slot-scope="data">
                                <b-container style="padding-left: 0px">
                                    <b-row>
                                        <b-col>Sebrae: {{ parseFloat(data.variacaoSebrae || 0).toFixed(2) }}</b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>Parceiro: {{ parseFloat(data.variacaoPArceiro || 0).toFixed(2)}}</b-col>
                                    </b-row>
                                </b-container>                                                          
                            </template>
                            <template slot="historicoAditivos" slot-scope="data">
                                <div v-if="data.historicoAditivos && data.historicoAditivos.length > 0">
                                    <b-container v-for="(item, index) in data.historicoAditivos" :key="index" style="padding-left: 0px">
                                        <!-- Si el objeto está vacío, mostramos "Sin datos" -->
                                        <div v-if="Object.keys(item).length === 0">
                                            <b-row>
                                                <b-col class="text-left m-0">Sem Aditivos</b-col>
                                            </b-row>
                                        </div>
                                        <!-- Si el objeto no está vacío, mostramos los datos -->
                                        <div v-else >
                                            <b-row>
                                                <b-col>Aditivo: {{ item.numero }}</b-col>                                        
                                            </b-row>
                                            <b-row>
                                                <b-col>Sebrae: {{ item.Sebrae.toFixed(2) }}</b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>Parceiro: {{ item.Parceiro.toFixed(2) }}</b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col >Total: {{ item.Total.toFixed(2) }}</b-col>
                                            </b-row>
                                        </div>
                                    </b-container>
                                </div>
                                <!-- Si no hay elementos en el arreglo, mostramos "Sin datos" -->
                                <div v-else>
                                    <b-row>
                                        <b-col class="text-left m-0">Sem Aditivos</b-col>
                                    </b-row>
                                </div>
                            </template>

                        </app-tabela>
                    </div>
                </b-card-body>
                    </b-tab>
                    <b-tab title="Relatório Comparativo">
                        <b-card-body>
                            <div>
                                <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                                ></app-erros-box>
                                <app-tabela
                                    idTabela="tbRelatorioComparativo"
                                    :itens="relatorioComparativo"
                                    :campos="relatorio"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false">
                        
                                    <template slot="acoe" slot-scope="data">
                                        <btn-mostrar-eventos
                                            v-if="$temAcessoView('CONV-PLANO-02')"
                                            @atualizarEvento="eventos = $event"
                                            @atualizarConsultoria="consultorias = $event"
                                            @receberAcao="acao = $event"
                                            :acao="data"
                                        ></btn-mostrar-eventos>
                                    </template>
                                    <template slot="natureza" slot-scope="data">
                                        <p  class="text-left m-0">
                                            {{ data.natureza }}
                                        </p>
                                    </template>
                                    <template slot="fonteDoRecurso" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.fonteDoRecurso }}
                                        </p>
                                    </template>
                                    <template slot="valorOriginal" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.valorOriginal }}
                                        </p>
                                    </template>                            
                                    <template slot="valorAtual" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.valorAtual || 0}}
                                        </p>
                                    </template>
                                    <template slot="variacaoNominal" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.variacaoNominal}}
                                        </p>
                                    </template>
                                    <template slot="variacaoPorcentual" slot-scope="data">
                                        <b-container>
                                            <b-row>
                                                <b-col>{{ data.varicaoPorcentual }}</b-col>
                                            </b-row>                                    
                                        </b-container> 
                                        
                                        <!--<p class="text-left m-0">
                                            <span>{{ String(data.variacaoPorcentual) + "teste" }}</span>
                                        </p>-->
                                    </template>
                                </app-tabela>
                            </div>
                        </b-card-body>
                    </b-tab>
                </b-tabs>
                
            </b-card>
        </div>
        <div v-if="mostrarEventos">
            <eventos
                :convenio="convenio"
                :acao="acao"
                :eventos="eventos"
                :consultorias="consultorias"
                @atualizarAcao="atualizarLista()"
                @voltarAcao="voltarAcao()">
            </eventos>
        </div>
    </div>
    </template>
    
    <script>
        import ConveniosServicos from '../ConveniosServicos'
        import BtnInserirAcaoPlanoTrabalho from '../cadastro/acaoPlanoTrabalho/BtnInserirAcaoPlanoTrabalho'
        import BtnCancelarAcao from '../cadastro/acaoPlanoTrabalho/BtnCancelarAcao'
        import BtnAtualizarAcao from '../cadastro/acaoPlanoTrabalho/BtnAtualizarAcao.vue'
        import BtnMostrarEventos from '../cadastro/acaoPlanoTrabalho/BtnMostrarEventos.vue'
        import Eventos from '../cadastro/acaoPlanoTrabalho/eventos/Eventos.vue'
    
        export default {
            components: {
                BtnInserirAcaoPlanoTrabalho,
                BtnCancelarAcao,
                BtnAtualizarAcao,
                BtnMostrarEventos,
                Eventos
            },
    
            props: {
                convenio: {
                    type: Object,
                    default: () => ({})
                }
            },
    
            data() {
                return {
                    erros: [],
                    eventos: null,
                    consultorias:null,
                    acao:null,
                    itensPorPagina: 5,
                    acoesPlanoTrabalho: [],
                    campos: [
                        {
                            key: 'nomeAcao',
                            label: 'Nome da Ação',
                            filterable: true,
                            sortable: true
                        },
                        {
                            key: 'situacao',
                            label: 'Situação',
                            filterable: true,
                            sortable: true,
                            tdClass: 'text-nowrap'
                        },                        
                        {
                            key: 'valoresConvenioOriginal',
                            label: 'Valores Convenio Original',
                            filterable: true,
                            sortable: true,
                            tdClass: 'text-nowrap'
                        },
                        {
                            key: 'valoresAtuais',
                            label: 'Valores Atuais',
                            filterable: true,
                            sortable: true,
                            tdClass: 'text-nowrap'
                        },
                        {
                            key: 'variacao',
                            label: 'Variação',
                            filterable: true,
                            sortable: true,
                            tdClass: 'text-nowrap'
                        },
                        {
                            key: 'historicoAditivos',
                            label: 'Histórico Aditivos',
                            filterable: true,
                            sortable: true,
                            tdClass: 'text-nowrap'
                        },
                        {
                            key: 'acoes',
                            label: ''
                        }
                        ],
                    relatorio: [
                        {
                            key: 'acao',
                            label: 'Ação',
                            filterable: true,
                            sortable: true
                        },
                        {
                            key: 'natureza',
                            label: 'Natureza',
                            filterable: true,
                            sortable: true
                        },
                        {
                            key: 'fonteDoRecurso',
                            label: 'Fonte do Recurso',
                            filterable: true,
                            sortable: true
                        },
                        {
                            key: 'valorOriginal',
                            label: 'Valor Original',
                            filterable: true,
                            sortable: true
                        },
                        {
                            key: 'valorAtual',
                            label: 'Valor Atual',
                            filterable: true,
                            sortable: true
                        },
                        {
                            key: 'variacaoNominal',
                            label: 'Variação Nominal',
                            filterable: true,
                            sortable: true
                        },
                        {
                            key: 'varicaoPorcentual',
                            label: 'Variação Porcentual',
                            filterable: true,
                            sortable: true
                        }
                    ]
                    ,
                    relatorioComparativo: []
                    }
                },
    
            methods:{
            getAditivos(idAplicacaoRecurso){
                let aditivosH = []
                let cont = 1
                this.convenio.aditivos.forEach(element => {
                    if(element.idAplicacaoRecurso === idAplicacaoRecurso){
                        aditivosH.push({
                            numero: cont,
                            Sebrae: element.nuValorSebraeAtual,
                            Parceiro: element.nuValorParceiroAtual,
                            Total: element.nuValorSebraeAtual + element.nuValorParceiroAtual
                        })
                        cont += 1
                    }
                })
                return aditivosH
            },
                atualizarLista(){
                    this.$store.dispatch('addRequest')
                    ConveniosServicos.obterPorId(this.convenio.idConvenio)
                    .then(response => {
                        if (response) {
                            if (response.success) {
                                this.acoesPlanoTrabalho = response.acoesPlanoTrabalho 
                                this.relatorioComparativo = response.relatorioComparativo                             
                            }
                            else{
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    })
                },
                atualizarEvento(eventos) {
                    this.eventos = eventos
                },
                atualizarConsultoria(consultorias) {
                    this.consultorias = consultorias
                },
                receberAcao(acao) {
                    this.acao = acao
                },
                voltarAcao(){
                    this.eventos = null;
                    this.consultorias = null;
                }
            },
            computed: {
                mostrarEventos() {
                    return this.eventos != null
                },
                mostrarConsultorias() {
                    return this.consultorias != null
                }
            },
            watch:{
                convenio(){
                    if(this.convenio){
                        this.acoesPlanoTrabalho = []
                        this.relatorioComparativo = []
                        var cont = 1
                        this.convenio.aplicacoesRecursos.forEach(element => {
                            this.acoesPlanoTrabalho.push({
                                nomeAcao: element.acao.descricao,
                                situacao: "Cadastrado",
                                nuValorOriginalSebrae: element.nuValorEconomicoSebrae + element.nuValorFinanceiroSebrae,
                                nuValorOriginalParceiro: element.nuValorEconomicoParceiro + element.nuValorFinanceiroParceiro,
                                nuValorSebraeAtual: element.nuValorSebraeAtual,
                                nuValorParceiroAtual: element.nuValorParceiroAtual,
                                variacaoSebrae: (element.nuValorEconomicoSebrae + element.nuValorFinanceiroSebrae) - element.nuValorSebraeAtual,
                                variacaoPArceiro: (element.nuValorEconomicoParceiro + element.nuValorFinanceiroParceiro) - element.nuValorParceiroAtual,
                                historicoAditivos: this.getAditivos(element.idAplicacaoRecurso) 
                            })
                        });
                        this.convenio.relatorioComparativo.forEach( element => {
                            this.relatorioComparativo.push({
                            acao: element.acao,
                            natureza: element.natureza,
                            fonteDoRecurso: element.fonteDoRecurso,
                            valorOriginal: element.valorOriginal,
                            valorAtual: element.valorAtual,
                            variacaoNominal: element.variacaoNominal,
                            varicaoPorcentual: element.variacaoPorcentual + '%'
                            })
                        });
                    }
                }
            },
    }
    </script>
    
